var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleDropReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_805_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8037 3.48759C11.8037 1.9129 13.0803 0.636353 14.655 0.636353H17.5062C19.0809 0.636353 20.3574 1.9129 20.3574 3.48759V4.91321H23.2087V7.76445C23.2087 8.5518 22.5704 9.19007 21.7831 9.19007H10.3781C9.59075 9.19007 8.95248 8.5518 8.95248 7.76445V4.91321H11.8037V3.48759ZM16.0806 3.48759C15.2932 3.48759 14.655 4.12586 14.655 4.91321C14.655 5.70056 15.2932 6.33883 16.0806 6.33883C16.8679 6.33883 17.5062 5.70056 17.5062 4.91321C17.5062 4.12586 16.8679 3.48759 16.0806 3.48759ZM7.52686 6.33883H3.25V32H28.9112V6.33883H24.6343V7.76445C24.6343 9.33915 23.3578 10.6157 21.7831 10.6157H10.3781C8.8034 10.6157 7.52686 9.33915 7.52686 7.76445V6.33883ZM24.1591 21.5454C24.1591 25.8759 20.6486 29.3864 16.3182 29.3864C11.9878 29.3864 8.47727 25.8759 8.47727 21.5454C8.47727 17.215 11.9878 13.7045 16.3182 13.7045C20.6486 13.7045 24.1591 17.215 24.1591 21.5454ZM22.8523 21.5454C22.8523 25.1541 19.9268 28.0795 16.3182 28.0795C12.7095 28.0795 9.78409 25.1541 9.78409 21.5454C9.78409 17.9368 12.7095 15.0114 16.3182 15.0114C19.9268 15.0114 22.8523 17.9368 22.8523 21.5454ZM13.7658 20.7138L16.3182 16.9716L18.8706 20.7138L18.8695 20.7148C19.3174 21.2842 19.5852 22.0067 19.5852 22.7929C19.5852 24.63 18.1225 26.1193 16.3182 26.1193C14.5138 26.1193 13.0511 24.63 13.0511 22.7929C13.0511 22.0067 13.319 21.2842 13.7669 20.7148L13.7658 20.7138ZM18.7684 23.6245C18.7684 24.543 18.0371 25.2877 17.1349 25.2877C16.2328 25.2877 15.5014 24.543 15.5014 23.6245C15.5014 22.7059 16.2328 21.9612 17.1349 21.9612C18.0371 21.9612 18.7684 22.7059 18.7684 23.6245Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_1375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.3636,
    height: 31.3636,
    fill: "white",
    transform: "translate(0.636475 0.636353)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleDropReport);
export default __webpack_public_path__ + "static/media/SingleDropReport.7b665c0012f8ce094a42f0faee38515d.svg";
export { ForwardRef as ReactComponent };